module.exports = __webpack_public_path__ + "img/theme-light.b065df89.png";